<div class="modal-header">
	<h2 class="mt-2" >
		<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
			<g fill="none" fill-rule="evenodd">
				<g fill="#0CC5D1">
					<path
						d="M32.786 0C33.456 0 34 .544 34 1.214v13.358c0 .322-.128.63-.356.858L15.43 33.644c-.474.475-1.243.475-1.717 0L.356 20.287c-.475-.474-.475-1.243 0-1.717L18.57.356c.228-.228.536-.356.858-.356zM31.57 2.429h-11.64l-17 17 11.64 11.64 17-17V2.429zM25.5 4.857c2.012 0 3.643 1.631 3.643 3.643 0 2.012-1.631 3.643-3.643 3.643-2.012 0-3.643-1.631-3.643-3.643 0-2.012 1.631-3.643 3.643-3.643zm0 2.429c-.67 0-1.214.543-1.214 1.214 0 .67.543 1.214 1.214 1.214.67 0 1.214-.543 1.214-1.214 0-.67-.543-1.214-1.214-1.214z"
						transform="translate(-704 -231) translate(440 199) translate(214 20) translate(0 12) translate(50)" />
				</g>
			</g>
		</svg>
		<ng-container i18n="@@add_store_type.add_store_type">Add Store Type</ng-container>
	</h2>

	<p>
		<ng-container i18n="@@add_store_type.store_type_noticed">Hello {{ userInfo?.full_name }}!<br> We noticed you haven’t added your store type yet, kindly add it up now so we can serve you better.</ng-container>
	</p>
</div>
<div class="modal-body">
	<form class="add-store-type" [formGroup]="addStoreTypeForm" (ngSubmit)="onSubmit()" #storeTypeForm="ngForm">
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('store_type').errors && addStoreTypeForm.get('store_type').errors.required}">
			<label for="store_type" i18n="@@add_store_type.store_type">Store Type</label>
			<select nice-select formControlName="store_type" (change)="changeStoreType()">
				<option value="product" i18n="@@common.product">Product</option>
				<option value="service" i18n="@@common.service">Service</option>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
		
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('business_type').errors && addStoreTypeForm.get('business_type').errors.required}">
			<label for="business_type" i18n="@@add_business_type.business_type">Business Type</label>
			<select nice-select formControlName="business_type">
				<ng-container *ngFor="let businessType of businessTypes">
					<option [value]="businessType.value">{{ businessType.displayName }}</option>
				</ng-container>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('company_type').errors && addStoreTypeForm.get('company_type').errors.required}">
			<label for="company_type" i18n="@@add_company_type.company_type">Company Type</label>
			<select nice-select formControlName="company_type">
				<ng-container *ngFor="let companyType of companyTypes">
					<option [value]="companyType">{{ companyType }}</option>
				</ng-container>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('business_name').errors && addStoreTypeForm.get('business_name').errors.required}">
			<label for="store_type" i18n="@@business.business_name">Business Name</label>
			<input type="text" formControlName="business_name" name="business_name" />
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('phone').errors }">
			<label for="phone" i18n="@@general.phone">Phone</label>
			<input type="number" formControlName="phone" name="phone" />
			<span class="field-error" *ngIf="addStoreTypeForm.get('phone').errors.required" i18n="@@error.required">Required</span>
			<span class="field-error" *ngIf="addStoreTypeForm.get('phone').errors?.pattern" i18n="@@error.invalid_number">Invalid phone number</span>
			<span class="field-error" *ngIf="addStoreTypeForm.get('phone').errors?.phoneTaken" i18n="@@error.invalid_number">Phone is already taken</span>
		</fieldset>
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('profession').errors && addStoreTypeForm.get('profession').errors.required}">
			<label for="profession" i18n="@@business.profession">Profession</label>
			<input type="text" formControlName="profession" name="profession" />
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
		<fieldset class="half" [ngClass]="{'has-error': submitted && addStoreTypeForm.get('size_of_team').errors && addStoreTypeForm.get('size_of_team').errors.required}">
			<label for="size_of_team" i18n="@@business.size_of_team">Size of Your Team</label>
			<input type="number" formControlName="size_of_team" name="size_of_team" />
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
	</form>
</div>
<div class="modal-footer">
	<button type="button" class="tu-btn blue" form="ngForm" (click)="storeTypeForm.ngSubmit.emit()" i18n="@@add_store_type.add_store_type">
		Add Store Type & more
	</button>
</div>
